import { UserRole } from '../../shared/VolunteerApplicationServiceTypes';
import { NotAPreceptorCard } from '../applicant/NotAPreceptorCard';
import { ApplicationsListContainer } from './ApplicationsList';
import { useFunctionaryHome } from './useFunctionaryHome';
import { StartDateNotStarted } from './StartDateNotYetAssigned';
import { EndDateExpiry } from './EndDateExpriy';
import useUserSession from '../../hooks/useUserSession';
import { PreworkMentorApplicationsListContainer } from './PreworkMentorApplicationsList';

export const FunctionaryHome = () => {
	const { batchDetails, messageToShow, dateBasedFunctionaryHome } =
		useFunctionaryHome();
	const dateChecker = dateBasedFunctionaryHome();
	const { selectedRole } = useUserSession();

	switch (messageToShow) {
		case 'FUNCTIONARY_IS_NOT_A_PRECEPTOR':
			return <NotAPreceptorCard />;
	}

	const roleInLower = selectedRole?.toLowerCase();

	const confirmStartDate =
		roleInLower && roleInLower in (dateChecker ?? {})
			? (dateChecker as Record<string, { startDate?: boolean }>)[roleInLower]
					?.startDate
			: undefined;

	const confirmEndDate =
		roleInLower && roleInLower in (dateChecker ?? {})
			? (dateChecker as Record<string, { endDate?: boolean }>)[roleInLower]
					?.endDate
			: undefined;

	if (
		selectedRole &&
		[
			UserRole.SNP_ADMIN,
			UserRole.ZC,
			UserRole.CARE_TEAM,
			UserRole.SCREENING_ADMIN,
			UserRole.NPS_ADMIN,
			UserRole.PREWORK_ADMIN,
			UserRole.EXAM_ADMIN,
		].includes(selectedRole)
	) {
		return <ApplicationsListContainer />;
	}
	if (selectedRole === UserRole.PREWORK_MENTOR) {
		return <PreworkMentorApplicationsListContainer />;
	}

	if (!confirmStartDate && confirmEndDate) return <StartDateNotStarted />;
	if (selectedRole === UserRole.PROPOSER) {
		if (confirmStartDate && confirmEndDate) {
			return <ApplicationsListContainer />;
		}
	}
	if (selectedRole === UserRole.APPROVER) {
		return <ApplicationsListContainer />;
	}
	if (batchDetails?.name) return <EndDateExpiry />;
	return null;
};
